import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Button, Paper, Typography} from '@material-ui/core';
import BikeIcon from '@material-ui/icons/DirectionsBikeTwoTone';
import StarIcon from '@material-ui/icons/Star';
import i18n from '../../i18n';

const styles = () => ({
  card: {
    position: 'absolute',
    top: 10,
    left: 10,
    padding: 10,
  },
  label: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: 10,
  },
  sponsoredIcon: {
    color: '#333',
    fontSize: 18,
    marginLeft: 6,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 16,
  },
});

class BikeReservationCard extends React.Component {
  geocoder = new window.google.maps.Geocoder();

  constructor(props) {
    super(props);
    this.state = {
      bikeAddress: null,
    };
  }

  refreshBikeAddress() {
    this.geocoder.geocode({location: this.props.bike.location}, (results, status) => {
      if (status == 'OK' && results && results.length > 0) {
        this.setState({bikeAddress: results[0].formatted_address});
      } else {
        this.setState({bikeAddress: i18n.t('map.bikeReservationCard.unknownAddress')});
      }
    });
  }

  componentDidMount() {
    // this.refreshBikeAddress();
  }

  componentDidUpdate(prevProps) {
    if (this.props.bike === prevProps.bike) return;

    // this.refreshBikeAddress();
  }

  render() {
    const {bike, onReserve, onRental, classes} = this.props;

    return (
      <Paper elevation={8} className={classes.card}>
        <Typography variant="body2" color="secondary" className={classes.label} gutterBottom>
          <BikeIcon color="disabled" className={classes.icon} />
          {bike.bikeNumber}
          {bike.isSponsored && (
            <StarIcon className={classes.sponsoredIcon} titleAccess="Rower sponsorski" />
          )}
        </Typography>
        {/*<Typography className={classes.label} gutterBottom><LocationIcon color="disabled"
                                                                         className={classes.icon}/> {this.state.bikeAddress}
        </Typography>*/}
        <Typography variant="caption">{i18n.t('map.bikeReservationCard.valid')}</Typography>
        <div className={classes.actions}>
          <Button size="small" color="primary" variant="contained" onClick={() => onRental(bike)}>
            {i18n.t('map.bikeReservationCard.rentalBikeButton')}
          </Button>
          <Button size="small" color="secondary" onClick={() => onReserve(bike)}>
            {i18n.t('map.bikeReservationCard.reserveButton')}
          </Button>
        </div>
      </Paper>
    );
  }
}

BikeReservationCard.propTypes = {
  classes: PropTypes.object.isRequired,
  bike: PropTypes.object.isRequired,
  onReserve: PropTypes.func.isRequired,
  onRental: PropTypes.func.isRequired,
};

export default withStyles(styles)(BikeReservationCard);
